import { useEffect, useState } from "react";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#why", label: "Pourquoi nous" },
  { href: "#pricing", label: "Tarifs" },
  { href: "#portfolio", label: "Réalisations" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Logo />

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="px-4 py-2 text-sm text-zinc-300 hover:text-white rounded-md transition-colors hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <a
            href="#contact"
            data-testid="nav-cta"
            className="hidden lg:inline-flex items-center gap-2 rounded-md bg-violet-600 hover:bg-violet-500 transition-all px-4 py-2 text-sm font-semibold text-white shadow-violet pulse-violet"
          >
            Devis gratuit
          </a>

          <button
            type="button"
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-white/10 bg-white/5"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {open && (
          <div
            data-testid="mobile-menu"
            className="lg:hidden pb-4 pt-2 border-t border-white/5"
          >
            <div className="flex flex-col gap-1">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="px-3 py-2 rounded-md text-sm text-zinc-300 hover:bg-white/5"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex justify-center rounded-md bg-violet-600 hover:bg-violet-500 px-4 py-2 text-sm font-semibold text-white shadow-violet"
              >
                Devis gratuit
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
